/**
 * Calcula a idade com base na data de nascimento.
 * @param birthDate - Data de nascimento no formato 'YYYY-MM-DD'
 * @returns Idade em anos
 */
export const calculateAge = (birthDate: string): number => {
  const birth = new Date(birthDate);
  const today = new Date();
  let age = today.getFullYear() - birth.getFullYear();
  const monthDiff = today.getMonth() - birth.getMonth();
  if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birth.getDate())) {
    age--;
  }
  return age;
};
